var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "statement-list" },
    [
      _c(
        "div",
        { staticClass: "statement-list-filter" },
        [
          _c("SelectBox", {
            attrs: { options: _vm.dateOptions },
            on: { update: _vm.updateDateHandler },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "result-main-body" },
        [_c("StatementTable", { ref: "statementTable" })],
        1
      ),
      _vm.isMobile ? _c("BurgerMenu") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }